import { render, staticRenderFns } from "./VerifiedPopup.vue?vue&type=template&id=2d0794d5&scoped=true&"
import script from "./VerifiedPopup.vue?vue&type=script&lang=js&"
export * from "./VerifiedPopup.vue?vue&type=script&lang=js&"
import style0 from "./VerifiedPopup.vue?vue&type=style&index=0&id=2d0794d5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0794d5",
  null
  
)

component.options.__file = "VerifiedPopup.vue"
export default component.exports